import React, { useMemo } from 'react';
import classNames from 'classnames';

import styles from './globalHeroNavStyles.module.scss';

/**
 * Renders resort/region navigation with background hero image.
 */
export const GlobalHeroNav = ({
  title,
  backgroundPhoto,
}: {
  title: string,
  backgroundPhoto: string,
}) => {
  const headerStyle = useMemo(() => ({
    backgroundImage: `linear-gradient(rgba(7, 51, 74, 0.4), rgba(7, 51, 74, 0.7)), url(${backgroundPhoto})`,
  }), [backgroundPhoto]);

  return (
    <div
      className={classNames(styles.header)}
      style={headerStyle}
    >
      <div className={classNames(styles.content)}>
        <div className={classNames(styles.title)}>
          <h1>{title}</h1>
        </div>
      </div>
    </div>
  );
};
